import { Helmet } from 'react-helmet';

import { CONTACT_INFO } from '../navbar/NavbarWithPopoverOnAccent/NavbarNavigateOptions';

/**
 * LocalBusiness Schema.org JSON-LD injected once at the app root.
 * Helps Google Knowledge Panel, Maps, and rich results pick up
 * business name, address, hours, phone, and social profiles.
 */
const LocalBusinessJsonLd = () => {
    const data = {
        '@context': 'https://schema.org',
        '@type': 'ProfessionalService',
        '@id': 'https://linaresprocorp.com/#business',
        name: 'Linares Pro Family Service Corp',
        image: 'https://linaresprocorp.com/assets/images/logo512.png',
        url: 'https://linaresprocorp.com',
        telephone: CONTACT_INFO.phoneHref.replace('tel:', ''),
        email: CONTACT_INFO.email,
        priceRange: '$$',
        address: {
            '@type': 'PostalAddress',
            streetAddress: CONTACT_INFO.address.line1,
            addressLocality: 'Miami Lakes',
            addressRegion: 'FL',
            postalCode: '33014',
            addressCountry: 'US',
        },
        geo: {
            '@type': 'GeoCoordinates',
            latitude: 25.9127174,
            longitude: -80.29946,
        },
        areaServed: [
            { '@type': 'City', name: 'Miami Lakes' },
            { '@type': 'City', name: 'Hialeah' },
            { '@type': 'City', name: 'Miami' },
            { '@type': 'AdministrativeArea', name: 'Florida' },
        ],
        openingHoursSpecification: [
            {
                '@type': 'OpeningHoursSpecification',
                dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday'],
                opens: '18:00',
                closes: '22:00',
            },
            {
                '@type': 'OpeningHoursSpecification',
                dayOfWeek: 'Saturday',
                opens: '10:00',
                closes: '17:00',
            },
        ],
        sameAs: [
            CONTACT_INFO.social.instagram,
            CONTACT_INFO.social.facebook,
        ],
        availableLanguage: ['English', 'Spanish'],
        hasOfferCatalog: {
            '@type': 'OfferCatalog',
            name: 'Services',
            itemListElement: [
                { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Credit Education & Coaching', url: 'https://linaresprocorp.com/credit_repair' } },
                { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Tax Preparation', url: 'https://linaresprocorp.com/taxes' } },
                { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Insurance Services', url: 'https://linaresprocorp.com/insurance' } },
                { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Notary Public', url: 'https://linaresprocorp.com/notary' } },
                { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Travel Booking', url: 'https://linaresprocorp.com/travel' } },
                { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Unemployment Assistance', url: 'https://linaresprocorp.com/unemployment' } },
                { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Workforce Documents', url: 'https://linaresprocorp.com/workforce' } },
            ],
        },
    };

    return (
        <Helmet>
            <script type="application/ld+json">{JSON.stringify(data)}</script>
        </Helmet>
    );
};

export default LocalBusinessJsonLd;
